<template>
  <div style="display: inline">
    <el-button
      class=" btn"
      type="primary"
      @click="dialogVisible = true"
    >
      CLIENT LOGIN
    </el-button>
    <el-dialog
      title="Send Client Login Details"
      :visible.sync="dialogVisible"
      width="300px"
    >
      <el-form
        ref="invite_form"
        :model="form"
        :rules="rules"
      >
        <el-form-item
          prop="email"
        >
          <span class="left">Email:</span>
          <el-input
            v-model="form.email"
            size="mini"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="mini"
          @click="dialogVisible = false"
        >Cancel</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="send_invite_email('invite_form')"
        >Send Email</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


import {defaultInput} from '../../utilities/DefaultInput';

export default {
  props: {
    account_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        email: '',
        account_id: ''
      },
      rules: {
        email: [{ required: true, message: 'Please Input Email', trigger: 'change' }],
      }
    };
  },
  watch: {
    dialogVisible: function (newVal) {
      if(newVal == true) {
        this.$nextTick(()=>{defaultInput();});
      }
    }
  },
  methods: {
    send_invite_email(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.account_id = this.account_id;
          this.$http.post('/send_client_login', {form: this.form}).then(
            () => {
              this.$message({
                message: 'Email sent',
                type: 'success',
              });
              this.dialogVisible = false;
            },
            (response) => {
              this.$message({
                type: 'error',
                message:
                      'Couldn\'t send invite email: ' +
                      response.data.errors,
              });
            }
          );
        }
      });
    }
  }
}
;
</script>
<style scoped>
.left {float: left;}
</style>
